import { render, staticRenderFns } from "./JohnDeerling.vue?vue&type=template&id=4ac240f2&scoped=true&"
import script from "./JohnDeerling.vue?vue&type=script&lang=js&"
export * from "./JohnDeerling.vue?vue&type=script&lang=js&"
import style0 from "./JohnDeerling.vue?vue&type=style&index=0&id=4ac240f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac240f2",
  null
  
)

export default component.exports